import { connect } from 'react-redux';
import WidgetDisplay from '../components/WidgetDisplay';

const mapStateToProps = _state => {
	return {
		widgetState: _state.widgetState
	};
};

const Widget = connect(mapStateToProps)(WidgetDisplay);

export default Widget;



// WEBPACK FOOTER //
// ./src/containers/Widget.jsx